import React, { useState, useEffect } from 'react';
import { GmapsBusiness } from './GmapsBusiness';
import { BarCodeReader } from './BarCodeReader';

import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Sheet, SheetTrigger, SheetContent, SheetTitle, SheetDescription } from "@/components/ui/sheet";

import * as gs from "genericsuite";
const isWindowWide = gs.ui.isWindowWide;
const isMobileDevice = gs.ui.isMobileDevice;

// import "./Registry.css"
export const Registry = () => {
  const [barcode, setBarcode] = useState('');
  const [nearbyStores, setNearbyStores] = useState([]);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [otherStore, setOtherStore] = useState('');
  const [otherStoreName, setOtherStoreName] = useState('');
  const [otherOptSelected, setOtherOptSelected] = useState(false);
  const [otherStoreAddress, setOtherStoreAddress] = useState(null);
  const [mapShow, setMapShow] = useState(false); // Only used for desktop
  const [isSheetOpen, setIsSheetOpen] = useState(false); // For mobile Sheet
  const [error, setError] = useState(null);

  useEffect(() => {
    // Get current location
    navigator.geolocation.getCurrentPosition((position) => {
      setCurrentLocation({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });
    });
  }, []);
  
  const handleOtherStore = (event) => {
    event.preventDefault();
    let data = {
      name: otherStoreName,
      location: currentLocation,
      address: otherStoreAddress,
    }
    // console.log('Selected store (event.target.store.value):', event.target.store.value);
    console.log('Selected store (otherStoreName):', otherStoreName);
    console.log('Selected other store object (data):', data);
    setOtherStore(data);
  };
  
  const handleSubmit = (event) => {
    event.preventDefault();
    // Submit form data (barcode, selected store or other store)
    console.log('Barcode:', barcode);
    console.log('Selected store:', event.target.store.value);
    if (event.target.store.value === 'other') {
      console.log('Other store:', otherStore);
    }
  };
  
  const handleMapShow = (event) => {
    event.preventDefault();
    setMapShow(!mapShow);
  };

  if (error) {
    return (
        <div>
            <h2>Error</h2>
            <p>{error}</p>
        </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-6 w-full max-w-2xl mx-auto p-2 md:p-4">
      {/* Barcode Scanner Section */}
      <Card className="w-full">
        <CardHeader>
          <CardTitle>Scan or Enter Product</CardTitle>
          <CardDescription>Use your camera or enter a barcode manually</CardDescription>
        </CardHeader>
        <div className="flex flex-col gap-4 p-4">
          <BarCodeReader setBarcodeExternal={setBarcode} setExternalError={setError} />
          <Input
            placeholder="Enter barcode manually"
            value={barcode}
            onChange={e => setBarcode(e.target.value)}
            className="w-full"
            name="barcode"
            aria-label="Barcode input"
          />
        </div>
      </Card>

      {/* Store Selection Section */}
      <Card className="w-full">
        <CardHeader>
          <CardTitle>Select Store</CardTitle>
          <CardDescription>Choose a store or add a new one</CardDescription>
        </CardHeader>
        <div className="flex flex-col gap-4 p-4">
          <Select onValueChange={val => setOtherOptSelected(val === 'other')}>
            <SelectTrigger className="w-full" aria-label="Store select">
              <SelectValue placeholder="Select a store" />
            </SelectTrigger>
            <SelectContent>
              {nearbyStores && nearbyStores.map((store) => (
                <SelectItem key={store.name} value={store.name}>{store.name}</SelectItem>
              ))}
              <SelectItem value="other">Other</SelectItem>
            </SelectContent>
          </Select>
          {otherOptSelected && (
            <div className="flex flex-col gap-2">
              <Input
                placeholder="Other store name"
                name="otherStoreName"
                value={otherStoreName}
                onChange={e => setOtherStoreName(e.target.value)}
                aria-label="Other store name"
              />
              <Button type="button" variant="secondary" onClick={handleOtherStore}>
                Done
              </Button>
              {otherStore && (
                <p className="text-xs text-muted-foreground mt-2">
                  Selected Store: Name: {otherStore.name} | Address: {otherStore.address} | Location: {otherStore.location?.lat}, {otherStore.location?.lng}
                </p>
              )}
            </div>
          )}
        </div>
      </Card>

      {/* Map Section with Sheet for mobile */}
      <Card className="w-full">
        <CardHeader>
          <CardTitle>Find Store on Map</CardTitle>
          <CardDescription>Pick a store location visually</CardDescription>
        </CardHeader>

        <div className="flex flex-col gap-4 p-4">
          {/* Show as Sheet on small screens, inline on desktop */}
          <div className={isWindowWide || isMobileDevice ? "hidden" : "block"}>
            <Sheet open={isSheetOpen} onOpenChange={setIsSheetOpen}>
              <SheetTrigger asChild>
                <Button type="button" variant="outline">
                  {isSheetOpen ? "Hide Map" : "Show Map"}
                </Button>
              </SheetTrigger>
              <SheetContent side="bottom" className="h-[60vh] p-0 flex flex-col">
                <SheetTitle>Map</SheetTitle>
                <SheetDescription>Find a store on the map</SheetDescription>
                <div
                  className="flex-1 min-h-0 map-main-container"

                >
                  <GmapsBusiness
                    setNearbyStoresExternal={setNearbyStores}
                    setAddressExternal={setOtherStoreAddress}
                    setExternalError={setError}
                  />
                </div>
              </SheetContent>
            </Sheet>
          </div>
          <div
            className={isWindowWide || isMobileDevice ? "block w-full h-80 rounded-md overflow-hidden border" : "hidden"}
          >
            <GmapsBusiness
              setNearbyStoresExternal={setNearbyStores}
              setAddressExternal={setOtherStoreAddress}
              setExternalError={setError}
            />
          </div>
        </div>
      </Card>

      {/* Submit Button */}
      <div className="flex justify-end">
        <Button type="submit" className="w-full md:w-auto">Submit</Button>
      </div>
    </form>
  );
};
